import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function VoiceAssistantCard() {
  const { user } = useSelector((state) => state.profile);
  const { t } = useTranslation();

  return (
    <section className="bg-white rounded-2xl shadow-lg grid grid-cols-1 md:grid-cols-3 items-center p-6 md:p-10 gap-6 md:gap-10">
      {/* Image */}
      <div className="flex justify-center">
        <img
          src="https://storage.googleapis.com/a1aa/image/34a6bde4-aafa-494e-3143-9d24253b512a.jpg"
          alt="AI Assistant"
          className="w-[220px] h-[330px] object-contain"
        />
      </div>

      {/* Microphone Button */}
      <div className="flex flex-col items-center gap-3">
        <Link to="/dashboard/teacher/chatbot" className="group">
          <div className="relative w-24 h-24">
            {/* Pulse Animation */}
            <span className="absolute inset-0 rounded-full bg-[#e0e7ff] animate-ping opacity-75"></span>
            <button
              aria-label={t("voiceAssistant.startButton")}
              className="relative z-10 bg-[#f3f5ff] rounded-full w-24 h-24 flex items-center justify-center shadow-lg hover:shadow-xl transition"
            >
              <i className="fas fa-comments text-[#3b56f5] text-3xl"></i>
            </button>
          </div>
        </Link>
        <p className="text-center text-sm text-gray-600 max-w-[160px]">
          {t("voiceAssistant.tapMessage")}
        </p>
      </div>

      {/* Welcome Message */}
      <div className="text-center md:text-right text-[#3b56f5] space-y-2">
        <h2 className="text-3xl font-bold">
          {t("voiceAssistant.welcome")}, {user?.name}
        </h2>
        <p className="text-base font-medium text-gray-700">
          {t("voiceAssistant.intro1")}{" "}
          <span className="font-semibold text-[#3b56f5]">
            {t("voiceAssistant.assistantName")}
          </span>
          , {t("voiceAssistant.intro2")}
        </p>
      </div>
    </section>
  );
}
